/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".row[_ngcontent-%COMP%]:after{content:\"\";display:table;clear:both}.row[_ngcontent-%COMP%]{padding:2%}.white-background[_ngcontent-%COMP%]{background-color:#fff}.gray-background[_ngcontent-%COMP%]{background-color:#f2f2f2}.navy-background[_ngcontent-%COMP%]{background-color:#001f45}.blue-background[_ngcontent-%COMP%]{background-color:#07639d}"];
export { styles as styles };
